import defaultAxios, { AxiosInstance } from 'axios';
import { AxiosAdapter } from './AxiosAdapter';
import { IRequestAdapter, RequestAdapters } from './RequestAdapter';
import { ConfigService, CoreService } from './services';
import { SignedAxiosAdapter } from './SignedAxiosAdapter';
import { IAuthTokenStore, ITokenStore, LocalAuthStore, LocalTokenStore } from './store';

interface ConfigureOptions {
  axios?: AxiosInstance;
  configService: ConfigService;
  tokenStore?: ITokenStore;
  authStore?: IAuthTokenStore;
  requestAdapters?: Required<Record<RequestAdapters, IRequestAdapter>>;
}
/**
 *
 * if (environments) {
 *   configService = new HttpConfigService(environments);
 * } else if (config) {
 *   configService = new LocalConfigService(config);
 * }
 * configService.configStore = configStore || new MemoryConfigStore();
 *
 */
export default function configure(coreInstance: CoreService, {
  axios = defaultAxios,
  tokenStore = new LocalTokenStore(),
  requestAdapters = {
    default: new AxiosAdapter(axios),
    sigv4: SignedAxiosAdapter.create(),
  },
  configService,
  authStore = new LocalAuthStore(),
}: ConfigureOptions) {
  tokenStore.environment = configService.currentEnvironment;
  coreInstance.requestAdapters = requestAdapters;
  coreInstance.api.tokens.tokenStore = tokenStore;
  coreInstance.api.auth.authStore = authStore;

  coreInstance.register('config', configService);
}